const initials = (name = "") =>
  name.trim().slice(0, 1).toUpperCase() || "?";

const FacilityAvatar = ({ name, logoUrl, size = "h-10 w-10" }) => (
  <div
    className={`${size} flex flex-shrink-0 items-center justify-center overflow-hidden rounded-xl bg-[#EEF0FB] text-[#2B3674] font-bold`}
  >
    {logoUrl ? (
      <img src={logoUrl} alt={`${name} logo`} className="h-full w-full object-cover" />
    ) : (
      initials(name)
    )}
  </div>
);

export default FacilityAvatar;
